import { TemplateRef } from "@angular/core";

export class CustomTemplate {
    columnName: string;
    templateName: TemplateRef<any>;
    hasPermission: boolean;
    data: any[];
}